import EditBookingPriceBreakdown from 'shared/components/EditBookingPriceBreakdown'
import { RateCurrency } from 'shared/price-utilities'

import './styles.scss'

const PriceBreakdown = ({
    rateTable,
    itemTotal,
    total,
    promoCode,
    currencySymbol,
    isMultipleBooking,
    additionalServices,
    additionalServicePrice,
    editedReservationNewTotalPrice,
    newPrice,
    oldPrice,
    amendmentFee,
    rate,
    showPriceDifference,
}) => {
    const totalPrice = additionalServicePrice()
        ? additionalServicePrice() + (isMultipleBooking ? itemTotal : total)
        : isMultipleBooking
          ? itemTotal
          : total

    return (
        <div className="price-summary">
            {rateTable &&
                rateTable.map((rateRow, index) => (
                    <div key={index} className="d-flex justify-content-between my-2">
                        <span className="mr-2">{rateRow.rateName}</span>
                        <RateCurrency rate={rate} value={rateRow.amount} currency={currencySymbol} />
                    </div>
                ))}
            {promoCode != null && (
                <div className="d-flex justify-content-between my-2 price-summary__discount">
                    <span>{promoCode.barcode}</span>
                    <RateCurrency value={-promoCode.promoDiscount} currency={currencySymbol} />
                </div>
            )}
            {additionalServices &&
                additionalServices.map((item, index) => (
                    <div key={index} className="d-flex justify-content-between my-2 ">
                        <span>{item.feeName}</span>
                        <RateCurrency value={item.value} currency={currencySymbol} />
                    </div>
                ))}
            {!isMultipleBooking && <hr className="price-summary__break" />}
            <div
                className={`d-flex justify-content-between my-2 ${
                    isMultipleBooking ? 'font-weight-bold' : 'is-single'
                } ${showPriceDifference && 'flex-column'}`}>
                {showPriceDifference ? (
                    <EditBookingPriceBreakdown
                        editedReservationNewTotalPrice={editedReservationNewTotalPrice}
                        newPrice={newPrice}
                        oldPrice={oldPrice}
                        amendmentFee={amendmentFee}
                        rate={rate}
                        isModal
                    />
                ) : (
                    <>
                        <T>{isMultipleBooking ? 'purchase.total.label' : 'purchase.total.to.pay.label'}</T>
                        <span className={`${isMultipleBooking ? '' : 'price-summary__price'}`}>
                            <RateCurrency value={totalPrice} currency={currencySymbol} />
                        </span>
                    </>
                )}
            </div>
        </div>
    )
}

PriceBreakdown.propTypes = {
    rateTable: PropTypes.arrayOf(
        PropTypes.shape({
            rateName: PropTypes.string,
            amount: PropTypes.number,
        })
    ),
    itemTotal: PropTypes.number,
    total: PropTypes.number,
    promoCode: PropTypes.shape({}),
    currencySymbol: PropTypes.string,
    isSingleBooking: PropTypes.bool,
}

export default PriceBreakdown
